export const userProfile = {
  user_alias: "Alias",
  user_name: "Name",
  user_lastName: "Last Name",
  user_email: "Email",
  user_phoneNumber: "Phone Number",
  user_birthdate: "Date of Birth",
  user_national_id: "ID Number",
  user_state: "State",
  user_city: "City",
  user_support_message: "To make any changes or updates to your profile, please contact our",
  user_support_link: "technical support",

  userProfileImageFormat: "Unsupported format",
  userProfileImageFormatDesc: "Only JPEG, JPG, or PNG images are allowed.",
  userProfileImageSize: "Image too large",
  userProfileImageSizeDesc: "The maximum allowed size is 3MB.",
  userProfileImageEdit: "Edit",
};
